import React from 'react';
import styled from '@emotion/styled';
import { orbAnimations } from './animations';
import { OrbData } from './utils';

const StyledGlowOrb = styled.div<{
  $size: number;
  $left: number;
  $top: number;
  $delay: number;
  $duration: number;
  $animIndex: number;
  $hue: number;
}>`
  position: absolute;
  left: ${({ $left }) => $left}%;
  top: ${({ $top }) => $top}%;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: ${({ $hue }) => `radial-gradient(circle, hsla(${$hue}, 60%, 55%, 0.4) 0%, transparent 70%)`};
  animation: ${({ $animIndex }) => orbAnimations[$animIndex % orbAnimations.length]} 
    ${({ $duration }) => $duration}s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
  filter: blur(30px);
  will-change: transform, opacity;
  opacity: 0.5;
`;

type GlowOrbProps = {
  data: OrbData;
};

export const GlowOrb: React.FC<GlowOrbProps> = ({ data }) => (
  <StyledGlowOrb
    $size={data.size}
    $left={data.left}
    $top={data.top}
    $delay={data.delay}
    $duration={data.duration}
    $animIndex={data.animIndex}
    $hue={data.hue}
  />
);
